import Stickyfill from 'stickyfill';

function initSticky(element) {
  let stickyfill = Stickyfill();
  stickyfill.add(element);
}

export default initSticky;
